/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartAnnotationsAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class SmartAnnotationsAPI {
		/**
		 * @function SmartAnnotationsAPI#isEnabled
		 * @description Determines whether smart annotations is enabled for the current content, regardless of the state.
		 * @returns {boolean} true if smart annotations is enabled for the content, otherwise false
		 */
		isAnnotationsEnabled() {}

		/**
		 * @function SmartAnnotationsAPI#getEnabledAnnotations
		 * @description Execute and wait for the SA execution response to be ready
		 * @returns {Promise} resolves when the annotation execution results are ready
		 */
		getEnabledAnnotations() {}

		/**
		 * @function SmartAnnotationsAPI#getAllSuggestedAnnotations
		 * @description Execute and wait for the SA execution response to be ready
		 * @returns {Promise} resolves when the annotation execution results are ready
		 */
		getAllSuggestedAnnotations() {}

		/**
		 * @function SmartAnnotationsAPI#supportsAnnotations
		 * @description Determines whether smart annotations is supported for the current content
		 * @returns {boolean} true if smart annotations is supported for the content, otherwise false
		 */
		supportsAnnotations() {}
	}

	return SmartAnnotationsAPI;
});
